import React from 'react';
import type { Types } from '@fiverr-private/theme';
import { Status } from '@fiverr-private/data_display';
import { Container } from '@fiverr-private/layout_components';
import { AppI18n } from '../../../i18n';

export const ModerationBadge = (props: Types.ContainerProps) => (
  <Container flexShrink="0" {...props}>
    <Status type="error">
      <AppI18n k="project_modal.moderation_badge" />
    </Status>
  </Container>
);
